import { default as _91_46_46_46cms_93MLY3rXdef4Meta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260923073950/pages/[...cms].vue?macro=true";
import { default as _91_46_46_46slug_93A48fiSdHETMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260923073950/pages/3d-projects/[...slug].vue?macro=true";
import { default as indexsDAYM8xNSxMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260923073950/pages/3d-projects/index.vue?macro=true";
import { default as _91_46_46_46slug_932Y9NnkOIOJMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260923073950/pages/akcii/[...slug].vue?macro=true";
import { default as indexCe7dGvNM0CMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260923073950/pages/akcii/index.vue?macro=true";
import { default as _91_46_46_46slug_930o9hJw8GlDMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260923073950/pages/articles/[...slug].vue?macro=true";
import { default as index2qXSwU9PGEMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260923073950/pages/articles/index.vue?macro=true";
import { default as indexIMTp7WS15HMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260923073950/pages/authorization/index.vue?macro=true";
import { default as index4dPTcTU9KxMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260923073950/pages/cart/index.vue?macro=true";
import { default as _91_46_46_46id_93mhkku8Rg3jMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260923073950/pages/cart/success/[...id].vue?macro=true";
import { default as _91_46_46_46slug_93QLmSdArveQMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260923073950/pages/catalog/[...slug].vue?macro=true";
import { default as indexIZgiDT35BhMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260923073950/pages/catalog/index.vue?macro=true";
import { default as _91_46_46_46slug_93O8Za9VC3LcMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260923073950/pages/catalogsearch/[...slug].vue?macro=true";
import { default as resultzN1qQgphKbMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260923073950/pages/catalogsearch/result.vue?macro=true";
import { default as index2mHra237moMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260923073950/pages/clear-page-slider/index.vue?macro=true";
import { default as _91_46_46_46slug_93r2iMLyiB26Meta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260923073950/pages/collection/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93FtJSgmlH8kMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260923073950/pages/fabriki/[...slug].vue?macro=true";
import { default as indexstQCTLtj90Meta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260923073950/pages/fabriki/index.vue?macro=true";
import { default as _91hash_93VXFOG2eb7bMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260923073950/pages/order-status/[hash].vue?macro=true";
import { default as _91_46_46_46slug_93NExYKzK68KMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260923073950/pages/product/[...slug].vue?macro=true";
import { default as indexZRNcTfyaSeMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260923073950/pages/profile/index.vue?macro=true";
import { default as indexZYocZn8xDAMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260923073950/pages/profile/orders/index.vue?macro=true";
import { default as indexkaYcja2jAoMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260923073950/pages/recently/index.vue?macro=true";
import { default as _91_46_46_46slug_9318n9fnRhNBMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260923073950/pages/sets/[...slug].vue?macro=true";
import { default as indexJK6gV9yzhEMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260923073950/pages/wishlist/index.vue?macro=true";
export default [
  {
    name: _91_46_46_46cms_93MLY3rXdef4Meta?.name ?? "cms",
    path: _91_46_46_46cms_93MLY3rXdef4Meta?.path ?? "/:cms(.*)*",
    meta: _91_46_46_46cms_93MLY3rXdef4Meta || {},
    alias: _91_46_46_46cms_93MLY3rXdef4Meta?.alias || [],
    redirect: _91_46_46_46cms_93MLY3rXdef4Meta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260923073950/pages/[...cms].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93A48fiSdHETMeta?.name ?? "3d-projects-slug",
    path: _91_46_46_46slug_93A48fiSdHETMeta?.path ?? "/3d-projects/:slug(.*)*",
    meta: _91_46_46_46slug_93A48fiSdHETMeta || {},
    alias: _91_46_46_46slug_93A48fiSdHETMeta?.alias || [],
    redirect: _91_46_46_46slug_93A48fiSdHETMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260923073950/pages/3d-projects/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexsDAYM8xNSxMeta?.name ?? "3d-projects",
    path: indexsDAYM8xNSxMeta?.path ?? "/3d-projects",
    meta: indexsDAYM8xNSxMeta || {},
    alias: indexsDAYM8xNSxMeta?.alias || [],
    redirect: indexsDAYM8xNSxMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260923073950/pages/3d-projects/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_932Y9NnkOIOJMeta?.name ?? "akcii-slug",
    path: _91_46_46_46slug_932Y9NnkOIOJMeta?.path ?? "/akcii/:slug(.*)*",
    meta: _91_46_46_46slug_932Y9NnkOIOJMeta || {},
    alias: _91_46_46_46slug_932Y9NnkOIOJMeta?.alias || [],
    redirect: _91_46_46_46slug_932Y9NnkOIOJMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260923073950/pages/akcii/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexCe7dGvNM0CMeta?.name ?? "akcii",
    path: indexCe7dGvNM0CMeta?.path ?? "/akcii",
    meta: indexCe7dGvNM0CMeta || {},
    alias: indexCe7dGvNM0CMeta?.alias || [],
    redirect: indexCe7dGvNM0CMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260923073950/pages/akcii/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_930o9hJw8GlDMeta?.name ?? "articles-slug",
    path: _91_46_46_46slug_930o9hJw8GlDMeta?.path ?? "/articles/:slug(.*)*",
    meta: _91_46_46_46slug_930o9hJw8GlDMeta || {},
    alias: _91_46_46_46slug_930o9hJw8GlDMeta?.alias || [],
    redirect: _91_46_46_46slug_930o9hJw8GlDMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260923073950/pages/articles/[...slug].vue").then(m => m.default || m)
  },
  {
    name: index2qXSwU9PGEMeta?.name ?? "articles",
    path: index2qXSwU9PGEMeta?.path ?? "/articles",
    meta: index2qXSwU9PGEMeta || {},
    alias: index2qXSwU9PGEMeta?.alias || [],
    redirect: index2qXSwU9PGEMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260923073950/pages/articles/index.vue").then(m => m.default || m)
  },
  {
    name: indexIMTp7WS15HMeta?.name ?? "authorization",
    path: indexIMTp7WS15HMeta?.path ?? "/authorization",
    meta: indexIMTp7WS15HMeta || {},
    alias: indexIMTp7WS15HMeta?.alias || [],
    redirect: indexIMTp7WS15HMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260923073950/pages/authorization/index.vue").then(m => m.default || m)
  },
  {
    name: index4dPTcTU9KxMeta?.name ?? "cart",
    path: index4dPTcTU9KxMeta?.path ?? "/cart",
    meta: index4dPTcTU9KxMeta || {},
    alias: index4dPTcTU9KxMeta?.alias || [],
    redirect: index4dPTcTU9KxMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260923073950/pages/cart/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46id_93mhkku8Rg3jMeta?.name ?? "cart-success-id",
    path: _91_46_46_46id_93mhkku8Rg3jMeta?.path ?? "/cart/success/:id(.*)*",
    meta: _91_46_46_46id_93mhkku8Rg3jMeta || {},
    alias: _91_46_46_46id_93mhkku8Rg3jMeta?.alias || [],
    redirect: _91_46_46_46id_93mhkku8Rg3jMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260923073950/pages/cart/success/[...id].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93QLmSdArveQMeta?.name ?? "catalog-slug",
    path: _91_46_46_46slug_93QLmSdArveQMeta?.path ?? "/catalog/:slug(.*)*",
    meta: _91_46_46_46slug_93QLmSdArveQMeta || {},
    alias: _91_46_46_46slug_93QLmSdArveQMeta?.alias || [],
    redirect: _91_46_46_46slug_93QLmSdArveQMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260923073950/pages/catalog/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexIZgiDT35BhMeta?.name ?? "catalog",
    path: indexIZgiDT35BhMeta?.path ?? "/catalog",
    meta: indexIZgiDT35BhMeta || {},
    alias: indexIZgiDT35BhMeta?.alias || [],
    redirect: indexIZgiDT35BhMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260923073950/pages/catalog/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93O8Za9VC3LcMeta?.name ?? "catalogsearch-slug",
    path: _91_46_46_46slug_93O8Za9VC3LcMeta?.path ?? "/catalogsearch/:slug(.*)*",
    meta: _91_46_46_46slug_93O8Za9VC3LcMeta || {},
    alias: _91_46_46_46slug_93O8Za9VC3LcMeta?.alias || [],
    redirect: _91_46_46_46slug_93O8Za9VC3LcMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260923073950/pages/catalogsearch/[...slug].vue").then(m => m.default || m)
  },
  {
    name: resultzN1qQgphKbMeta?.name ?? "catalogsearch-result",
    path: resultzN1qQgphKbMeta?.path ?? "/catalogsearch/result",
    meta: resultzN1qQgphKbMeta || {},
    alias: resultzN1qQgphKbMeta?.alias || [],
    redirect: resultzN1qQgphKbMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260923073950/pages/catalogsearch/result.vue").then(m => m.default || m)
  },
  {
    name: index2mHra237moMeta?.name ?? "clear-page-slider",
    path: index2mHra237moMeta?.path ?? "/clear-page-slider",
    meta: index2mHra237moMeta || {},
    alias: index2mHra237moMeta?.alias || [],
    redirect: index2mHra237moMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260923073950/pages/clear-page-slider/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93r2iMLyiB26Meta?.name ?? "collection-slug",
    path: _91_46_46_46slug_93r2iMLyiB26Meta?.path ?? "/collection/:slug(.*)*",
    meta: _91_46_46_46slug_93r2iMLyiB26Meta || {},
    alias: _91_46_46_46slug_93r2iMLyiB26Meta?.alias || [],
    redirect: _91_46_46_46slug_93r2iMLyiB26Meta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260923073950/pages/collection/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93FtJSgmlH8kMeta?.name ?? "fabriki-slug",
    path: _91_46_46_46slug_93FtJSgmlH8kMeta?.path ?? "/fabriki/:slug(.*)*",
    meta: _91_46_46_46slug_93FtJSgmlH8kMeta || {},
    alias: _91_46_46_46slug_93FtJSgmlH8kMeta?.alias || [],
    redirect: _91_46_46_46slug_93FtJSgmlH8kMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260923073950/pages/fabriki/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexstQCTLtj90Meta?.name ?? "fabriki",
    path: indexstQCTLtj90Meta?.path ?? "/fabriki",
    meta: indexstQCTLtj90Meta || {},
    alias: indexstQCTLtj90Meta?.alias || [],
    redirect: indexstQCTLtj90Meta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260923073950/pages/fabriki/index.vue").then(m => m.default || m)
  },
  {
    name: _91hash_93VXFOG2eb7bMeta?.name ?? "order-status-hash",
    path: _91hash_93VXFOG2eb7bMeta?.path ?? "/order-status/:hash()",
    meta: _91hash_93VXFOG2eb7bMeta || {},
    alias: _91hash_93VXFOG2eb7bMeta?.alias || [],
    redirect: _91hash_93VXFOG2eb7bMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260923073950/pages/order-status/[hash].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93NExYKzK68KMeta?.name ?? "product-slug",
    path: _91_46_46_46slug_93NExYKzK68KMeta?.path ?? "/product/:slug(.*)*",
    meta: _91_46_46_46slug_93NExYKzK68KMeta || {},
    alias: _91_46_46_46slug_93NExYKzK68KMeta?.alias || [],
    redirect: _91_46_46_46slug_93NExYKzK68KMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260923073950/pages/product/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexZRNcTfyaSeMeta?.name ?? "profile",
    path: indexZRNcTfyaSeMeta?.path ?? "/profile",
    meta: indexZRNcTfyaSeMeta || {},
    alias: indexZRNcTfyaSeMeta?.alias || [],
    redirect: indexZRNcTfyaSeMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260923073950/pages/profile/index.vue").then(m => m.default || m)
  },
  {
    name: indexZYocZn8xDAMeta?.name ?? "profile-orders",
    path: indexZYocZn8xDAMeta?.path ?? "/profile/orders",
    meta: indexZYocZn8xDAMeta || {},
    alias: indexZYocZn8xDAMeta?.alias || [],
    redirect: indexZYocZn8xDAMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260923073950/pages/profile/orders/index.vue").then(m => m.default || m)
  },
  {
    name: indexkaYcja2jAoMeta?.name ?? "recently",
    path: indexkaYcja2jAoMeta?.path ?? "/recently",
    meta: indexkaYcja2jAoMeta || {},
    alias: indexkaYcja2jAoMeta?.alias || [],
    redirect: indexkaYcja2jAoMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260923073950/pages/recently/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_9318n9fnRhNBMeta?.name ?? "sets-slug",
    path: _91_46_46_46slug_9318n9fnRhNBMeta?.path ?? "/sets/:slug(.*)*",
    meta: _91_46_46_46slug_9318n9fnRhNBMeta || {},
    alias: _91_46_46_46slug_9318n9fnRhNBMeta?.alias || [],
    redirect: _91_46_46_46slug_9318n9fnRhNBMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260923073950/pages/sets/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexJK6gV9yzhEMeta?.name ?? "wishlist",
    path: indexJK6gV9yzhEMeta?.path ?? "/wishlist",
    meta: indexJK6gV9yzhEMeta || {},
    alias: indexJK6gV9yzhEMeta?.alias || [],
    redirect: indexJK6gV9yzhEMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260923073950/pages/wishlist/index.vue").then(m => m.default || m)
  }
]